<template>
  <section>
    <h2 class="hide">전체</h2>
    <div class="tb-header clear">
        <div class="tb_sort fr">
            <input type="checkbox" name="" id="new" v-model="noneRead" @change="fNoneRead"><label for="new">{{ $i18nUtil.trans("button.paper.unread","미확인 보드 보기") }}</label>
            <input type="checkbox" name="" id="fav" v-model="filterBookmark" @change="fFilterBookmark"><label for="fav">{{ $i18nUtil.trans("button.favorite","즐겨찾기 보기") }}</label>
            <div class="dividing_line_ty1"></div>
            <CommonFilterD 
              :isCooperation="'cooperation'"
              :categoryList="categoryList"
              @updateCommonFilterD="updateCommonFilterD"/>
            <div class="droplayer icon setting large right nosel">
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on">설정</v-btn>
                </template>
                <div class="dropdown-list">
                  <!--  v-if="cooperationManageCountYn || cooperationManageYn" 
                        카테고리 관리버튼 항상 노출로 변경 : 조성기 0312 
                  -->
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <router-link :to="{ name: 'cooperationManage' }"><!-- v-if="cooperationManageCount != 0"  -->
                        <button type="button">
                          {{ $i18nUtil.trans("title.CooperationManageHeader.001","회의/협의 카테고리 관리") }}
                        </button>
                      </router-link>
                    </div>
                  </div>
                  <div class="dropdown-list-item" v-if='checkIncludeCategoryYn'>
                    <div class="tit">
                      <router-link :to="{ name: 'cooperationBoardManage' }" > 
                        <button type="button">{{ $i18nUtil.trans("title.CooperationBoardManageHeader.000","회의/협의 보드 관리") }}</button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </v-menu>
            </div>
        </div>
    </div><!-- //tb-header -->

    <!-- <div v-for="(category, index) in categoryList" :key="'category_' + index"></div> -->
      <CooperationBarod 
        ref="cooperationBoard"
        v-for="(category, index) in categoryList" :key="'category_' + index"
        :category="category"
        :noneRead="noneRead"
        :filterBookmark="filterBookmark" 
        :filterData="filterData" 
        @viewYn="viewYn"
        @moveCategoryMore="moveCategoryMore" 
        >
      </CooperationBarod>
      <div class="division" v-if="view">
          <!-- <div class="sub_tit_box clear">
              <h3 class="fl">전체 (0)</h3>
          </div>-->
          <div class="nodata-txt" v-if="categoryList.length == 0">
            {{ $i18nUtil.trans("search.018","참여중인 회의/협의가 없습니다.") }}
          </div> 
          <div class="nodata-txt" v-if="categoryList.length != 0">
            {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
          </div>
      </div>
  </section>
</template>

<script>
import CooperationBarod from "./CooperationBoard";
import CommonFilterD from "@/components/cowork/common/filter/CommonFilterD";
// import SpaceFilterBox from "@/components/cowork/general/filter/SpaceFilterBox";
import RegistBoardMoal from "../modal/RegistBoardModal" 
import { mapState, mapActions, mapMutations } from "vuex";

import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// Navigation error로 아래 내용으로 대체
import {Swiper as SwiperClass, Scrollbar, Navigation} from 'swiper/swiper.esm.js'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
// Swiper modules
SwiperClass.use([Scrollbar, Navigation])
// local component
const {directive} = getAwesomeSwiper(SwiperClass)

export default {
  props: ["categoryList","myUserId","headerNoneRead"],
  components: {
    CooperationBarod,
    CommonFilterD
    // SpaceFilterBox
  },
  directives: {
      swiper: directive
  },
  data(){
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      noneRead:false,
      filterBookmark:false,
      filterCategoryInfo :[],  
      getBoardListActionCount:0,

      view:false,
      invisibleCount:0,
      visibleCount:0,

      filterData:[],
      checkIncludeCategoryYn:false
    }
  },  
  watch:{
    categoryList(){
      // this.startProgressBar();
      // this.$refs.spaceFilterBox.setCategoryFilterInfo(this.categoryList);
      this.setCfrcNoneReadCount(-1);
      this.invisibleCount = 0;
      this.visibleCount = 0;
      this.noneRead=false;
      this.filterBookmark=false;
      for(let k in this.$refs.cooperationBoard){
          this.$refs.cooperationBoard[k].getCfrcPaperList();
      }
    },
    headerNoneRead(){
      this.noneRead = this.headerNoneRead;
    }
  },
  computed:{
    // ...mapState("shareInfo", ["cooperationManageYn"]),
    // ...mapState("shareInfo", ["cooperationManageCountYn"]),
    swiper() {
      return this.$refs.mySwiper.swiper
    }
    // ...mapState("cooperation", ["cooperationManageCount"]),
  },
  created(){
    this.checkIncludeCategory();
  },
  mounted(){
    if(this.categoryList.length == 0){
      this.view = true;
    }else{
      this.view = false;
    }
      
    // this.startProgressBar();
  },
  methods:{ 
    ...mapMutations("shareInfo", ["setCfrcNoneReadCount"]), 
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    filterInfo(data){ 
      data.myUserId=this.myUserId; 
      for(let k in this.$refs.cooperationBoard){
        this.$refs.cooperationBoard[k].setFilter(data);
      }
    },  
    viewYn(data){
      if(data){
        this.visibleCount++;
      }else{
        this.invisibleCount++; 
      } 
      if(this.visibleCount === 0){
        this.view = true;
      }else{
        this.view = false;
      }
    },
    fNoneRead(){
      this.visibleCount = 0;
      this.invisibleCount = 0;
    },
    fFilterBookmark(){
      this.visibleCount = 0;
      this.invisibleCount = 0;
    }, 
    moveCategoryMore(_categoryInfo){
      this.$emit("moveCategoryMore",_categoryInfo);
    },
    updateCommonFilterD(filterData){
      this.invisibleCount = 0;
      this.visibleCount = 0; 
      this.filterData = filterData;
    },
    checkIncludeCategory(){
      let obj = this;
      let reqData = {};
      reqData.params ={};
      reqData.req = obj.req;
      reqData.url = "/api/copaper/cooperation/checkIncludeCategory";
      reqData.method = "post"; 
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => {
          if(res.result.checkCategoryCount){ 
            obj.checkIncludeCategoryYn = true;
          }else{
            obj.checkIncludeCategoryYn = false;
          }
        })
        .catch(function(err) { console.log(err); });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/cooperation/base/CooperationAll.vue